<ng-container *ngIf="formPrincipal">
  <div class="title-section" style="flex-direction: row; justify-content: space-between">
    <h2 class="header-title">Seleccione un tipo de variable</h2>
    <div class="button-section">
      <button class="btn-cancel" mat-raised-button type="button" (click)="close()" appPermissionControl="P132B0001"><mat-icon>arrow_back</mat-icon>Volver</button>
    </div>
  </div>
  <div class="form-row">
    <div class="form-field flex-grow-1">
      <select required appPermissionControl="P132K0001" class="form-control" (change)="changeBoolean($event.target.value)">
        <option value="">--Selecciona--</option>
        <option value="apertura">Apertura</option>
        <option value="gastos">Gastos</option>
        <option value="bonificacion">Bonificación</option>
        <option value="liquidacion">Liquidación</option>
        <option value="extraordinarios">Extraordinarios</option>
        <option value="subsidio">Subsidio</option>
        <option value="cargosCierre">Cargos (Cierre)</option>
        <option value="cargosPago">Cargos (Pago)</option>
        <option value="intereses">Intereses</option>
      </select>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="formApertura">
  <app-def-apertura [modelRecived]="model"></app-def-apertura>
</ng-container>

<ng-container *ngIf="formGastos">
  <app-def-gastos [modelRecived]="model"></app-def-gastos>
</ng-container>

<ng-container *ngIf="formBonificacion">
  <app-def-bonificacion [modelRecived]="model"></app-def-bonificacion>
</ng-container>

<ng-container *ngIf="formLiquidacion">
  <app-def-liquidacion [modelRecived]="model"></app-def-liquidacion>
</ng-container>

<ng-container *ngIf="formExtraordinarios">
  <app-def-extraordinarios [modelRecived]="model"></app-def-extraordinarios>
</ng-container>

<ng-container *ngIf="formSubsidio">
  <app-def-subsidio [modelRecived]="model"></app-def-subsidio>
</ng-container>

<ng-container *ngIf="formCargosCierre">
  <app-def-cargos-cierre [modelRecived]="model"></app-def-cargos-cierre>
</ng-container>

<ng-container *ngIf="formCargosPago">
  <app-def-cargos-pagos [modelRecived]="model"></app-def-cargos-pagos>
</ng-container>

<ng-container *ngIf="formIntereses">
  <app-def-intereses [modelRecived]="model"></app-def-intereses>
</ng-container>
